import { JSX } from 'react';
import './calendarTimeView.css';

interface CalendarTimeViewProps {
    startDate: Date;
    endDate: Date;
}

const CalendarTimeView = ({ startDate, endDate }: CalendarTimeViewProps): JSX.Element => {
    
    const getDisplayDateRange = (): string => {
        const inSameYear = startDate.getFullYear() === endDate.getFullYear();
        const startMonth = inSameYear? startDate.toLocaleString('default', { month: 'short' }) : startDate.toLocaleString('default', { month: 'short' }) + ' ' + startDate.getFullYear();
        const endMonth = endDate.toLocaleString('default', { month: 'short' }) + ' ' + endDate.getFullYear();
        return `${startMonth} - ${endMonth}`;
    }

    const getDisplayDayTime = (startTime: Date, endTime: Date): string => {
        // Check if it's a full day event (starts at midnight and ends at midnight)
        const isFullDay = startTime.getHours() === 0 && 
                         startTime.getMinutes() === 0 && 
                         endTime.getHours() === 0 && 
                         endTime.getMinutes() === 0 &&
                         startTime.getDate() !== endTime.getDate();

        if (isFullDay) {
            return "Full Day";
        }

        const startHour = startTime.getHours() % 12 || 12;
        const endHour = endTime.getHours() % 12 || 12;
        const startMin = startTime.getMinutes().toString().padStart(2, '0');
        const endMin = endTime.getMinutes().toString().padStart(2, '0');
        const startAmPm = startTime.getHours() >= 12 ? 'PM' : 'AM';
        const endAmPm = endTime.getHours() >= 12 ? 'PM' : 'AM';

        if (startAmPm === endAmPm) {
            return `${startHour}:${startMin} - ${endHour}:${endMin} ${startAmPm}`;
        }
        return `${startHour}:${startMin} ${startAmPm} - ${endHour}:${endMin} ${endAmPm}`;
    }

    return (
        <div className='calendar-time-view'>
            <p>{getDisplayDateRange()}</p>
        </div>
    );
};

export default CalendarTimeView;
